module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/807382b3f60d8eeebb10875a243c6bf8.gif";